// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bottom_bar-oNhodvye {\n    font-size: 12px;\n    padding-bottom: 17px;\n    padding-right: 10px;\n}\n\n.comment_time-2Q8G1VtY {\n    padding-top: 4px;\n    color: #999;\n}\n\n.reply-g1UOn-am {\n    float: right;\n    line-height: 14px\n}\n\n.reply-g1UOn-am a {\n    color: #000;\n    text-decoration: none;\n}\n\n.reply-g1UOn-am a:hover {\n    text-decoration: underline;\n}\n\n.reported-Ec-Nldyp {\n    color: #c2c2c2;\n}\n\n.repNum-3qFYjPZh {\n    padding-left: 8px;\n    font: 16px georgia;\n    color: #f54343;\n}\n\n.repLine-3WYfo3iB {\n    display: inline-block;\n    padding: 0 8px;\n    color: #c2c2c2;\n}\n\n.bottom_box-2wpng23l {\n    padding: 7px 10px 15px 0;\n    margin: -10px 0 0 0;\n}\n", ""]);
// Exports
exports.locals = {
	"bottom_bar": "bottom_bar-oNhodvye",
	"comment_time": "comment_time-2Q8G1VtY",
	"reply": "reply-g1UOn-am",
	"reported": "reported-Ec-Nldyp",
	"repNum": "repNum-3qFYjPZh",
	"repLine": "repLine-3WYfo3iB",
	"bottom_box": "bottom_box-2wpng23l"
};
module.exports = exports;
